
import Main from "./Main";
import DfsComponent from "./DFS";
function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
